import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "../../components/app-toast";
import { APP_PATH } from "../../api/backendPath";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import {
  getLocalizedMessage,
  getLocalizedErrorMessage,
} from "../../utils/messageHelper";
import i18n from "../../i18n";

// ✅ 1. GET Doctor Profile
export const getDoctorProfile = createAsyncThunk(
  "doctorProfile/getDoctorProfile",
  async (_, { rejectWithValue }) => {
    const axiosPrivate = await useAxiosPrivate();
    try {
      const response = await axiosPrivate.get(
        `${process.env.REACT_APP_API_URL}${APP_PATH.doctorProfile}`,
      );
      return response.data.data;
      // if (response?.data?.status === true || response?.status === 200) {
      //   return response.data.data;
      // } else {
      //   toast.error(response?.data?.message || "Failed to fetch doctor profile");
      //   return rejectWithValue(response.data);
      // }
    } catch (error) {
      console.error("Error in getDoctorProfile:", error);
      const errMsg = getLocalizedErrorMessage(error, i18n);
      toast.error(errMsg);
      return rejectWithValue(errMsg);
    }
  },
);

// ✅ 2. UPDATE Doctor Profile
export const updateDoctorProfile = createAsyncThunk(
  "doctorProfile/updateDoctorProfile",
  async (data, { rejectWithValue }) => {
    const axiosPrivate = await useAxiosPrivate();
    try {
      const response = await axiosPrivate.put(
        `${process.env.REACT_APP_API_URL}${APP_PATH.doctorProfile}`,
        data,
      );

      if (response?.data?.status === true || response?.status === 200) {
        const message = getLocalizedMessage(response, i18n);
        toast.success(message);
        return response.data.data;
      } else {
        const message = getLocalizedErrorMessage({ response }, i18n);
        toast.error(message);
        return rejectWithValue(response.data);
      }
    } catch (error) {
      console.error("Error in updateDoctorProfile:", error);
      const errMsg = getLocalizedErrorMessage(error, i18n);
      toast.error(errMsg);
      return rejectWithValue(errMsg);
    }
  },
);

// ✅ 3. TOGGLE Patient Visibility
export const togglePatientVisibility = createAsyncThunk(
  "doctorProfile/togglePatientVisibility",
  async (visibility, { rejectWithValue }) => {
    const axiosPrivate = await useAxiosPrivate();
    try {
      const response = await axiosPrivate.put(
        `${process.env.REACT_APP_API_URL}${APP_PATH.doctorVisibility}`,
        { show_patient_count: visibility },
      );

      if (response?.data?.status === true || response?.status === 200) {
        const message = getLocalizedMessage(response, i18n);
        toast.success(message);
        return visibility;
      } else {
        const message = getLocalizedErrorMessage({ response }, i18n);
        toast.error(message);
        return rejectWithValue(response.data);
      }
    } catch (error) {
      console.error("Error in togglePatientVisibility:", error);
      const errMsg = getLocalizedErrorMessage(error, i18n);
      toast.error(errMsg);
      return rejectWithValue(errMsg);
    }
  },
);
